import { CommissionDetail, formatCommission } from "@platform/formatting-utils";
import { COVERAGE_FORM } from "@platform/rfp-core";

const {
  CURRENT_COMMISSION,
  CURRENT_COMMISSION_DETAIL,
  PLANS,
  REQUESTED_COMMISSION,
  REQUESTED_COMMISSION_DETAIL,
} = COVERAGE_FORM;

type Plan = Record<string, unknown>;

interface Coverage extends Record<string, unknown> {
  details?: { plans?: Plan[] } & Record<string, unknown>;
}

const derivePlan = (plan: Plan): Plan => {
  const current = plan[CURRENT_COMMISSION_DETAIL] as
    | CommissionDetail
    | undefined;
  const requested = plan[REQUESTED_COMMISSION_DETAIL] as
    | CommissionDetail
    | undefined;

  return {
    ...plan,
    ...(current?.type
      ? { [CURRENT_COMMISSION]: formatCommission(current) }
      : {}),
    ...(requested?.type
      ? { [REQUESTED_COMMISSION]: formatCommission(requested) }
      : {}),
  };
};

/**
 * Fills each plan's free-text commission field from its normalized detail.
 *
 * The Build Tab still reads the free text until it reads the discrete fields
 * directly, and the analyst's read-only view renders it, so a submission
 * carries both. Plans with no detail are returned untouched, which is what
 * keeps a coverage captured before this change from being rewritten.
 */
export const deriveCommissionText = (coverages: Coverage[]): Coverage[] =>
  coverages.map((coverage) => {
    const plans = coverage.details?.plans;

    if (!plans) {
      return coverage;
    }

    return {
      ...coverage,
      details: { ...coverage.details, [PLANS]: plans.map(derivePlan) },
    };
  });
